import {
    StreamsByStreamKeyState,
    StreamState,
} from 'streamsState/store/streamedData/StreamedDataState';

export type HistPriceVolStreamState = StreamState<HistPriceVolDataState>;
export type HistPriceVolStreamsState =
    StreamsByStreamKeyState<HistPriceVolDataState>;

export interface HistPriceVolDataState {
    data: HistPriceVolDataItem[];
}

export interface HistPriceVolDataItem {
    date: string;
    index: number;
    volume?: number;
    price?: number;
}

export const initialHistPriceVolDataState: HistPriceVolDataState = {
    data: [],
};

export const initialHistPriceVolStreamState: HistPriceVolStreamState = {
    data: initialHistPriceVolDataState,
    messages: [],
};
